import { fetchApi } from "../utils/fetchApi";

export function fetchOptimization({ filter = {}, options = {} }) {
  return fetchApi({ url: 'optimization', filter, options });
}